// src/components/ui/VitalTile.tsx
// A vital sign rendered as a tile that states its own cut-off when it is out
// of range, instead of only tinting amber and leaving the reader to know why
// — the Pre-Consult wireframe's marker 3.
//
// Thin on purpose: it is StatTile's chrome plus a `VitalCheck` from
// lib/vitalThresholds.ts. The value of it being its own component is that
// every screen showing a vital sign takes the ranges from the same module,
// so BP flags identically at Vitals, Pre-Consult, the read-only stage
// summary and (later) Consultation.
//
// Not yet built, and deliberately: the wireframe's inventory describes
// VitalTile as "StatTile + ClinicalSnapshot's private VitalTrend +
// threshold". The trend half needs a series of prior readings for this
// patient, and no endpoint on the OPD path returns one — the visit payload
// carries this visit's vitals only. Adding it means new API surface, which
// both the wireframe and the assessment explicitly ruled out of this phase.
import type { VitalCheck } from '@/lib/vitalThresholds';
import { StatTile } from './StatTile';

export interface VitalTileProps {
  icon: string;
  label: string;
  value: string | number | null | undefined;
  unit?: string;
  /** From lib/vitalThresholds.ts — `checkBp`, `checkPulse`, `checkTemp`, … */
  check?: VitalCheck;
}

export function VitalTile({ icon, label, value, unit, check }: VitalTileProps) {
  return <StatTile icon={icon} label={label} value={value} unit={unit} warn={check?.warn} hint={check?.hint} />;
}
